import { useTranslation } from "react-i18next"
import mainBg from "./map.png"
import { Input, Button } from "components"
import { Box } from "theme-ui"
export const DefineRoute = () => {
 // language translator
 const { t } = useTranslation("translation")
 return (
  <div className="w-[96%] mx-auto pt-6">
   <div
    style={{
     backgroundImage: `url(${mainBg})`,
     backgroundPosition: "left",
     backgroundSize: "contain",
     backgroundRepeat: "no-repeat",
     width: "100%",
     minHeight: "578px",
     position:"relative"
    }}
   >
    <Box bg="highlight" className="lg:w-[45%] w-[80%] rounded px-4 py-4 absolute top-6 left-14">
     <h1 className="font-semi">{t("edit")}</h1>
     <div className="flex items-center justify-between py-3">
      <label className="w-[30%]">{`${"Detector"}:`}</label>
      <Input className="py-2 px-2 bg-light-gray2 rounded" type="text" placeholder="60" />
     </div>
     <div className="flex lg:flex-row flex-col lg:justify-between">
      <div className="lg:w-[30%] w-full">
      <Button size={"lg"}>{t("delete")}</Button>
      </div>
      <div className="lg:w-[30%] w-full flex justify-center lg:py-0 py-2">
      <Button size={"lg"}>{t("cancel")}</Button>
      </div>
      <div className="lg:w-[30%] w-full">
      <Button size={"lg"}>{t("save")}</Button>
      </div>
     </div>
    </Box>
   </div>
  </div>
 )
}
